import { Directive, forwardRef, HostBinding, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { TranslationService } from 'app/core/internationalization/translation.service';
import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { A11yRole } from '../interfaces/a11y.interfaces';
import { normalizeAriaValue } from '../utils/a11y.util';

import { A11yLabelDirective } from './a11y-label.directive';

@Directive({
  selector: '[khA11yDialog]',
  providers: [{ provide: KH_A11Y_TARGET, useExisting: forwardRef(() => A11yDialogDirective) }]
})
export class A11yDialogDirective extends A11yLabelDirective implements A11yRole {
  private readonly _translationService = inject(TranslationService);
  private _defaultLabel = 'Dialog';

  @HostBinding('attr.role') public readonly role = 'dialog';
  @HostBinding('attr.aria-modal') public readonly ariaModal = 'true';
  @HostBinding('attr.tabindex') public readonly tabindex = '-1';

  public constructor() {
    super();
    this._translationService.translationsReady$
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this._defaultLabel = this._translationService.instant('A11Y_DIALOG.DIALOG') || this._defaultLabel;
      });
  }

  protected override get ariaLabelValue(): string | null {
    return normalizeAriaValue(this.a11yLabel) ?? this._defaultLabel;
  }
}
